import {ProductImageCarousel} from "./modules/ProductCarousels";
import SimpleLightbox from "simplelightbox";
import {AjaxCart} from "./modules/AjaxCart";
import {BundlePicker} from "./modules/BundlePicker";


ProductImageCarousel();

const galleryLightbox = () => {
    new SimpleLightbox('.woocommerce-product-gallery__wrapper a', {
        showCounter: false,
        history: false,
        captions: false,
        captionSelector: self
    });

}


const reviewsLightbox = ()=> {
    new SimpleLightbox('.product-reviews__image', {
        showCounter: false,
        history: false,
        captions: false,
        captionSelector: self
    });
}


reviewsLightbox();
galleryLightbox();

AjaxCart();

$(document).ready(function () {
    BundlePicker();
});
